module.exports = __webpack_public_path__ + "assets/img/DarkBackground.f44a8841.svg";